var jade = require("/opt/actions-runner/_work/DI-Plan-Go-web/DI-Plan-Go-web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div id=\"map\" ng-class=\"downtime.numberOfDisplays(auth.daysUntilPasswordExpires!==null &amp;&amp; auth.daysUntilPasswordExpires &lt;= 14)\">\n  <div id=\"googleMaps\"></div>\n  <div id=\"openLayers\"></div>\n</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/map.jade
 ** module id = 86
 ** module chunks = 1
 **/